import React, { useEffect, useState } from "react";
import { Modal, Form, Container, Col, Row, Badge } from "react-bootstrap";
import { useAssignJobMutation, useDeleteJobMutation, useGetAllUsersQuery } from "../../store";
import {
  CustomTable,
  DeleteButton,
  LoadingBox,
  MessageBox,
  MotionDiv,
  useTitle,
  ViewButton,
} from "../../components";
import { useGetAllJobsQuery } from "../../store";
import { Link, redirect, useNavigate } from "react-router-dom";
import { ImCross } from "react-icons/im";
import { FaCheck, FaUserPlus, FaUserTimes } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { ChatButton } from "../../components/layout/CustomTable";
import { ConfirmationModal, DateInput, SelectInput } from "../../components/layout/CustomForm";
import { toast, ToastContainer } from "react-toastify";
import { toastOptions } from "../../utils/error";
import { useGetAllpropertyQuery } from "../../store/api/property_preference";
import ApprovalButton from "./ApprovalButton";
// import AssignJobModal from "./AssignJobModal"; // Import the new AssignJobModal component

const column = [
  "Sr No.",
  
  "Cost of property",
  "Cost of appraiser",
  "Status",
  "Created At",
  "Updated At",
  
  "Actions",
];

const AssignJobModal = ({ show, onHide, job, getAllJobs }) => {
  const { isLoading, isError, property,  error, endpointName, refetch } =
    useGetAllpropertyQuery();
  const lastAssignedAppraiserIndex = job?.assigned_appraiser?.length - 1;

  const [appraiserId, setAppraiserId] = useState(
    job?.assigned_appraiser[lastAssignedAppraiserIndex]?.appraiser?.id || ""
  );
  const [assignJob, { isLoading: isAssignLoading }] = useAssignJobMutation();

  const handleAssign = async () => {
    console.log(appraiserId, job.id);
    try {
      const response = await assignJob({ id: job.id, userId: appraiserId });
      if (response.error && !response.error.data.success) {
        toast.error(response.error?.data?.message, toastOptions);
        onHide();
        return;
      }

      toast.success("Appraiser assigned successfully", toastOptions);
      onHide();
      getAllJobs();
    } catch (error) {
      toast.error(error.message);
      console.error("Failed to assign job:", error);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {job?.isAssigned ? "Reassign Appraiser" : "Assign Appraiser"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="appraiserSelect">
          <Form.Label>Select Appraiser</Form.Label>
          <Form.Control
            as="select"
            value={appraiserId}
            onChange={(e) => setAppraiserId(e.target.value)}
          >
            {/* Default option */}
            <option disabled={true} value="">
              Select an active Appraiser
            </option>

            {/* Filter available users */}
            {property &&
              property.users.filter((user) => user.available).length > 0 ? (
                property.users
                .filter((user) => user.available)
                .map((user) => (
                  <option value={user.id} key={user.id}>
                    {user.name}
                  </option>
                ))
            ) : (
              <option disabled={true} value="">
                No active Appraisers
              </option>
            )}
          </Form.Control>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          disabled={!appraiserId}
          variant="primary"
          onClick={handleAssign}
        >
          {job?.isAssigned ? "Reassign" : "Assign"}
          {isAssignLoading && (
            <LoadingBox style={{ height: "1rem", width: "1rem" }} />
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const JobStatusBadge = ({ status }) => {
  const getStatusVariant = (status) => {
    switch (status) {
      
      case true:
        return "success"; // Green
      case false:
        return "danger"; // Red
      default:
        return "secondary"; // Gray
    }
  };

  return <Badge bg={getStatusVariant(status)}>{status ? 'Approved' : 'Rejected'}</Badge>;
};

// Usage
const job = { status: "Approved" }; // Example status
<JobStatusBadge status={job.status} />;
const PropertyPreference = () => {
  useTitle("Property Management");

  const [currentPage, setCurrentPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [jobId, setJobId] = useState("");
  const [job, setJob] = useState(null);
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    job_status: "", // For example: "Assigned", "Not Assigned"
    from: "",
    to: "",
  });

  const { isLoading, isFetching, isError, data, error, refetch ,success} =
    useGetAllpropertyQuery({
      page: currentPage,
      limit: resultPerPage,
      ...filters,
    });

  const [deleteJob, { isLoading: isDeleteLoading, isSuccess: isDeleteSuccess, isError: isDeleteError }] = useDeleteJobMutation()

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters((prev) => ({
      job_status: "", // For example: "Assigned", "Not Assigned"
      from: "",
      to: "",
    }));
  };

  console.log("Data: ", data );

  const pageHandler = (p) => {
    setCurrentPage(p);
  };

  const handleAssignJob = (job) => {
    setJob(job);
    setShowAssignModal(true);
  };

  const handleDelete = (id) => {
    setJobId(id);
    setShowConfirmationModal(true);
  };

  const handleOnHide = () => {
    setShowConfirmationModal(false)
  }

  const deleteHandler = async (e) => {
    e.preventDefault();
    await deleteJob(jobId);
  };

  useEffect(() => {
    if (data) {
      setJobs(data?.quotations);
    }
  }, [data]);

  useEffect(() => {
    if (isDeleteSuccess) {
      refetch()
    }
  }, [isDeleteSuccess])

  return (
    <>
      <MotionDiv>
        {isError ? (
          <MessageBox variant="danger">
            {error?.data?.error?.message}
          </MessageBox>
        ) : (
          <>
            <div>
             <Link to={'/admin/property_type'}> <Button className="mb-2" >Go to Service type section</Button></Link>
            </div>
          
            <CustomTable
              loading={isFetching}
              column={column}
              rowNo={resultPerPage}
              rowProps={{ setResultPerPage }}
              paging={true}
              pageProps={{
                numOfPages: data?.totalPages,
                curPage: currentPage,
              }}
              pageHandler={pageHandler}
            >
              {jobs.length > 0 ? (
                jobs.map((job, i) => (
                  <tr key={job?.id} className="odd">
                    <td className="text-center">
                      {(currentPage - 1) * resultPerPage + i + 1}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {job?.cost}
                    </td><td style={{ textTransform: "capitalize" }}>
                      {job?.cost_of_appraiser}
                    </td>
                   
                    <td style={{ textTransform: "capitalize" }}>
                     <JobStatusBadge status={job.approved}/>
                    </td>
                    <td style={{ textTransform: "capitalize" }}>{job.created_at}</td>
                    <td>${job.updated_at}</td>
                    <td className="text-center" >
                       <ApprovalButton value={'Approve'} id={job?.id} status={'Approved'} disable={job.approved}/>
                      <div className="mt-1 cursor-pointer" >
                        <ApprovalButton  value={'Reject'} id={job?.id} status={'Rejected'} disable={job.approved}/>
                      </div>  
                    </td>

                    {/* <td>{new Date(job.preferred_date).toLocaleDateString()}</td> */}
                    {/* <td className="text-center">
                      {job.assigned_appraiser.length > 0 ? (
                        <FaCheck className="green" />
                      ) : (
                        <ImCross className="red" />
                      )}
                    </td> */}
                    {/* <td className="text-center">
                      {Boolean(job.is_rush_req) ? (
                        <FaCheck className="green" />
                      ) : (
                        <ImCross className="red" />
                      )}
                    </td> */}
                    {/* <td className="text-center">
                      {job?.assigned_appraiser[0]?.appraiser.name ||
                        "Not Assigned"}
                    </td> */}
                    
                  </tr>
                ))) : (
                <tr>
                  <td colSpan={12} className="text-center">
                    No Data Found!
                  </td>
                </tr>
              )}
              {/* Delete Job */}
              <ConfirmationModal
                show={showConfirmationModal}
                onHide={handleOnHide}
                title="Delete Job"
                body="Do you really want to delete this Job ?"
                successMessage="Job Deleted Successfully!"
                submitHandler={deleteHandler}
                reducerProps={{
                  loading: isDeleteLoading,
                  success: isDeleteSuccess,
                  error: isDeleteError,
                }}
              ></ConfirmationModal>

              {/* Assign job modal */}
            
            </CustomTable>
          </>
        )}
      </MotionDiv>
      <ToastContainer />
    </>
  );
};

export default PropertyPreference;
